/** Query-key root shared by every global-settings hook (invalidate it to refresh all of them). */
export const GLOBAL_SETTINGS_ENTITY = 'settings';
